import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {RequestTransport} from "../Model/Model";
import {GetAllDistributionCenter} from "../../../../reduxToolkit/DistributionCenter/DistributionCenterApi";
import {
    GetAllServiceType,
} from "../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {GetEmployeeProviderLists} from "../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {toast} from "react-toastify";
import {
    CreateLogisticRequest, GetAllLogisticRequestById,
    UpdateLogisticRequest
} from "../../../../reduxToolkit/Logistics/logisticRequestSectionApi";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import routes from "../../../../Routes/routes";
import {errorMsg} from "../../../../Apis/functions";
import HandleChange from "../../../../Helpers/HandleChange";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const CreateUpdateRequestApp =()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [getAllDistributionCenter, setGetAllDistributionCenter] = useState([])
    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [getAllSupplier, setGetAllSupplier] = useState([]);
    const [data, setData] = useState({...RequestTransport});
    const [disabled, setDisabled] = useState(false)
    const [emptyFields, setEmptyFields] = useState(false)
    const { handleChange } = HandleChange({ model: data, setModel: setData });
    const [isValidDeliveryAt, setIsValidDeliveryAt] = useState(true);

    useEffect(() => {
        if(data.departureAt && data.deliveryAt)
            if(data.deliveryAt > data.departureAt) setIsValidDeliveryAt(true);
            else setIsValidDeliveryAt(false);
    }, [data.departureAt, data.deliveryAt]);

    useEffect(()=>{
        dispatch(GetAllDistributionCenter()).then(({payload:{data:{data}}})=>{
            setGetAllDistributionCenter(data)
        });
        dispatch(GetAllServiceType()).then(({payload:{data:{data}}})=>{
            setGetAllServiceType(data)
        });
        dispatch(GetEmployeeProviderLists()).then(({payload: {data: { data }}}) => {
                setGetAllSupplier(data);
            },
        );
    },[dispatch])

    useEffect(() => {
        if(id){
            getData();
        }
    }, [id]);

    const getData = () => {
        dispatch(GetAllLogisticRequestById(id)).then(({payload:{data:{data,success}}})=>{
            if(success){
                setData(RequestTransport.set(data));
                setEmptyFields(false);
                setDisabled(true);
            }
        })
    }

    const handleClear = () => {
        setData({...data.clear()});
    };

    const handleCreate = () => {
        if (!data.isValid() || !isValidDeliveryAt) {
            setEmptyFields(true);
            return;
        }

        const payload = id
            ? { id: id, statusId: data.status.id, ...data.toRegister()}
            : data.toRegister();

        const action = id
            ? UpdateLogisticRequest(payload)
            : CreateLogisticRequest(payload);

        dispatch(action).then(({payload:{data:{success, code}}}) => {
            if(success){
                if (id) {
                    getData();
                    toast.success(t('has_been_updated_successfully'));
                } else {
                    toast.success(t('has_been_created_successfully'));
                    navigate(routes.transportRequest.list)
                }
                setEmptyFields(false);
            }else {
                errorMsg(code);
            }
        })
    };
    return {
        DEV,
        permission,
        handleCreate,
        handleClear,
        handleChange,
        data,
        emptyFields,
        getAllDistributionCenter,
        disabled,
        getAllServiceType,
        getAllSupplier,
        id,
        isValidDeliveryAt
    }
}
